// cn(): shadcn/ui's class helper. clsx joins conditional classes; tailwind-merge drops the earlier of
// two classes that set the same property, so a caller's className wins over a primitive's default.
//
// tailwind-merge must know this theme's scales: Tailwind's defaults are switched off in theme.css and
// replaced by token names (text-13, rounded-12, shadow-2, bg-wp-panel). Without this, text-13 and
// text-wp-text would look alike to it and one would silently drop the other.
import { clsx } from "clsx";
import { extendTailwindMerge } from "tailwind-merge";
const colors = [
    ...["midnight", "navy", "deep", "component", "royal", "blue", "cyan", "sky", "sky-2", "ice"].map((c) => `br-${c}`),
    ...["mist", "white", "rule", "rule-2", "ink", "ink-2", "ink-3"].map((c) => `br-${c}`),
    ...["ok", "ok-soft", "caution", "caution-ink", "caution-soft", "stop", "stop-soft"],
    ...["bg", "bg-2", "panel", "panel-2", "line", "line-strong", "text", "text-2", "text-3"].map((c) => `wp-${c}`),
    ...["accent", "accent-ink", "action", "user-bubble", "glass", "glass-strong", "glass-border"].map((c) => `wp-${c}`),
    "transparent",
    "current",
    "inherit",
];
const twMerge = extendTailwindMerge({
    override: { theme: { color: colors } },
    extend: {
        theme: {
            text: ["11", "12", "13", "14", "15", "16", "18", "22", "28", "40"],
            radius: ["4", "8", "12", "16", "pill"],
            shadow: ["1", "2", "3", "wp-glow"],
            leading: ["tight", "body"],
        },
    },
});
export function cn(...inputs) {
    return twMerge(clsx(inputs));
}
/** The theme's focus ring (mockups/kit/surface.css: 2px accent outline, 2px off the control). */
export const focusRing = "focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-wp-accent";
/** WCAG 2.2 target size: no interactive primitive is smaller than 24 by 24 CSS px. */
export const minTarget = "min-h-6 min-w-6";
//# sourceMappingURL=cn.js.map